<template>
  <div>
    <div class="wrapper"
         style="font-weight: bold;text-align: center;font-size: 25px;margin-bottom: 0;margin-top: 100px">{{title}}
    </div>
    <div class="wrapper" style="text-align: center;margin-top: 0;margin-bottom: 0">{{releaseDate}}</div>
    <div class="wrapper" id="content">
      <p class="ql-editor" v-html="content"></p>
    </div>
  </div>
</template>

<script>
  import '../../assets/css/main.css'
  import 'bootstrap/dist/css/bootstrap.min.css'
  import 'bootstrap/dist/js/bootstrap.min.js'
  import api from "../../api";
  import {dateStr2Times} from '../../util/TimeTransition'

  export default {
    name: "HotInform",
    data() {
      return {
        title: "",//标题
        releaseDate: "",//发布时间
        content: "",//正文内容
      }
    },
    methods: {
      getQueryString(name) {
        let after = window.location.hash.split("?")[1];
        if (after) {
          let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
          let r = after.match(reg);
          if (r != null) {
            return decodeURIComponent(r[2]);
          } else {
            return null;
          }
        }
      }
    },

    created() {
      let vue = this
      this.title = ""
      let id = this.getQueryString("id")
      api.notice.getById(id).then(function (response) {
        if (response == null) {
          return null
        }
        if (response.data.code === "0") {
          let result = response.data.result
          vue.title = result.title
          vue.releaseDate = dateStr2Times(result.issueTime)
          //document.getElementById("content").innerHTML = result.content
          vue.content = result.content
        }
      })
    },

  }
</script>

<style scoped>
  .wrapper {
    text-align: left;
    width: 1200px;
    margin: 60px auto;
    text-indent: 35px
  }

  .wrapper > p {

  }

  .news_nav {
    font-size: 15px;
    color: #333;
    line-height: 30px;
    margin-top: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #eee
  }

  .news_content p {
    font-size: 14px;
    line-height: 32px;
    margin-bottom: 25px;
    text-indent: 2em;
  }

  .newsList_num {
    height: 16px;
    width: 16px;
    border-radius: 100%;
    background-color: wheat;
    color: orange;
    display: inline-block;
    vertical-align: middle;
    line-height: 17px;
    text-align: center
  }

  .badge {
    background-color: crimson;
    margin-left: 8px
  }

  .news_dl1 {
    margin-left: 25px
  }

  .news_dl1 dd {
    font-size: 12px;
    line-height: 30px;
    color: #333;
  }

  .news_dl1 dd a {
    text-decoration: none
  }
</style>



// WEBPACK FOOTER //
// src/page/Layout/HotInform.vue